export const SET_ENTITIES = "SET_ENTITIES";
export const ADD_ENTITY = "ADD_ENTITY";
export const SET_ENTITY = "SET_ENTITY";
export const REMOVE_ENTITY = "REMOVE_ENTITY";
export const UPDATE_STATUS_ENTITY = "UPDATE_STATUS_ENTITY";
export const SEND_ENTITY_TOKEN = "SEND_ENTITY_TOKEN";
